<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'profile-index',
        title: 'Profile',
    };
</script>

<style scoped>

</style>
